export const appsAppGroupIdChartsWebhook = "/apps/:app_group_id/charts/webhook";
